<script setup lang="ts">
import { defineProps } from "vue";

defineProps<{
  showBlogBtn?: boolean;
  showBgImage?: boolean;
  withOverflow?: boolean;
}>();
</script>

<template>
  <slot />
</template>
